import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { SnackbarContext } from "../../../../../../contexts/Snackbar";
import { returnSubmit } from "../../../../../../enums/queryFunction/Submit";

export default function usePutWorkingHours(url, key) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();

  const queryKey = key;

  const submitCallback = async (obj) => {
    setLoading(true);
    mutate(obj);
  };

  function updateKey(key, newData) {
    queryClient.setQueryData([key], (oldData) => {
      if (!oldData) return oldData; // If no old data, return as is

      const dataMap = new Map(oldData.map((item) => [item.id, item]));

      newData.forEach((item) => {
        dataMap.set(item.id, item);
      });

      return Array.from(dataMap.values());
    });
  }

  const { mutate } = useMutation({
    mutationFn: (data) => returnSubmit(url, data),
    onSuccess: (response) => {
      if (response?.data) {
        if (Array.isArray(queryKey)) {
          queryKey.forEach((key) => updateKey(key, response?.data));
        } else {
          updateKey(queryKey, response?.data);
        }
      }

      handleSnackbar("successMessage", "success");
      setLoading(false);
    },
    onError: (error) => {
      handleSnackbar("errorMessage", "error");
      setLoading(false);
    },
  });

  return {
    submitCallback,
    loading,
  };
}
